<template>
	<div class="body-container">
		<headerNavigation :showLogin="false" @changeRegister="changeRegister"></headerNavigation>
		<template v-if="isMobile">
			<div class="global-header-spacer" style="height: 115px;"></div>
		</template>
		<div class="site-main-container">
			<div class="comp-login-register-container flow-checkout-container login page-login-register-container"
				style="display: flex;min-height: 1px;">
				<div class="login-register-panel">
					<div class="login-register-content">
						<div id="loginHandler">
							<div class="comp-login-handler-container">
								<div class="header-text-container">
									<h4 class="header-text" v-if="isForgetPwd">{{$t('login.forgotpassword')}}</h4>
									<h4 class="header-text" v-else>{{isRegister ? $t('login.firsthere') : $t('common.login2')}}</h4>
								</div>
								<div class="header-content-container" v-if="isRegister">
								    <p class="header-content" style="text-align: left;">{{$t('login.registertxt')}}</p>
								</div>
								<div class="comp-login-form-container">
									<template v-if="isRegister">
										<div ref="firstnameInputRef" class="site-form-group site-input form-group customer-form-group firstname">
											<label class="site-input-label" >*{{$t('user.firstname')}}</label>
											<input v-model="firstname" @focus="bindInputFocus('firstnameInputRef')" @blur="handleInputBlur('firstnameInputRef',firstname)" minlength="1" maxlength="50" autocomplete="off" class="site-input-group site-form-input form-control">
											<div class="input-message help-block" id="email"></div>
										</div>
										<div ref="lastnameInputRef" class="site-form-group site-input form-group customer-form-group firstname">
											<label class="site-input-label" >*{{$t('user.lastname')}}</label>
											<input v-model="lastname" @focus="bindInputFocus('lastnameInputRef')" @blur="handleInputBlur('lastnameInputRef',lastname)" minlength="1" maxlength="50" autocomplete="off" class="site-input-group site-form-input form-control">
											<div class="input-message help-block" id="email"></div>
										</div>
										<div ref="mobileInputRef" class="site-form-group site-input form-group customer-form-group email">
											<label class="site-input-label" >*{{$t('address.phone')}}</label>
											<input v-model="mobile" @focus="bindInputFocus('mobileInputRef')" @blur="handleInputBlur('mobileInputRef',mobile)" minlength="1" maxlength="50" autocomplete="off" class="site-input-group site-form-input form-control">
											<div class="input-message help-block" id="email"></div>
										</div>
									</template>
									<div ref="emailInputRef" class="site-form-group site-input form-group customer-form-group email">
										<label class="site-input-label" >*{{$t('login.email')}}</label>
										<input v-model="email" @focus="bindInputFocus('emailInputRef')" @blur="handleInputBlur('emailInputRef',email)" type="email" minlength="1" maxlength="50" autocomplete="off" class="site-input-group site-form-input form-control">
										<div class="input-message help-block" id="email"></div>
									</div>
									<template v-if="!isForgetPwd">
										<div ref="passwordInputRef" class="site-form-group site-input form-group customer-form-group password">
											<label class="site-input-label" > *{{$t('login.password')}}</label>
											<input v-model="password" @focus="bindInputFocus('passwordInputRef')" @blur="handleInputBlur('passwordInputRef',password)" placeholder="" name="password" type="password" minlength="1" maxlength="50" autocomplete="off" class="site-input-group site-form-input form-control">
											
											<a href="javascript:void(0)" class="password-decrypt">
												<span><i class="i-eye password-decrypt-icon"></i></span>
											</a>
											<div class="input-message help-block" id="password"></div>
										</div>
										<template v-if="!isRegister">
											<div class="site-form-group forgot-password-wrapper clearfix">
												<a href="javascript:void(0)" class="site-secondary-link password-link" @click="toForgetPwd(true)">{{$t('login.forgotpassword')}}</a>
											</div>
											<div class="form-group login-btn-wrapper">
												<div class="btn-container">
													<button type="submit" class="site-btn-primary" @click="confirmLogin">
														<span>{{$t('login.login2')}}</span>
													</button>
												</div>
											</div>
										</template>
										<template v-else>
											<div class="content-above-btn-container">
											    <p class="content-above-btn">{{$t('login.registerphonetxt')}}</p>
											</div>
											<div class="form-group register-btn-form-group">
											    <div class="btn-container register-btn-container">
											        <button @click="confirmRegister" type="button" class="site-btn-primary register-submit-btn">
											            <span>{{$t('login.createmyaccount')}}</span>
											        </button>
											    </div>
											</div>
										</template>
									</template>
									<template v-else>
										<div class="btn-form-group">
										    <div class="btn-container forgot-password-btn-container">
										        <button @click="confirmForget" type="button" class="site-btn-primary forgot-password-submit-btn login-reg-link">
										            <span>{{$t('login.resetpassword')}}</span>
										        </button>
										    </div>
										</div>
										<div class="site-form-group back-to-login-link-container">
										    <a href="javascript:void(0)" @click="toForgetPwd(false)" class="js-end-trap site-secondary-link-italic js-login-link back-button redirect-btn login-link forget-to-login">{{$t('login.backlogin')}}</a>
										</div>
									</template>
								</div>
								<template v-if="!isForgetPwd">
									<template v-if="!isRegister">
										<div class="form-group login-create-account-container">
											<div class="link-section">
												<p class="link-label register-content">
													<span>{{$t('login.firstuse')}}</span>
												</p>
												<button id="register_switch" @click="changeRegister(true)" class="login-create-link">
													<span>{{$t('login.createnewaccount')}}</span>
												</button>
											</div>
										</div>
									</template>
									<template v-else>
										<div class="form-group comp-disclaimer-form-group-container" style="margin-top: 15px;">
										    <div class="disclaimer-container">
										        <p class="terms-and-policy">{{$t('login.registeragreetxt1')}}<a href="javascript:void(0)" @click="openPage('/article?no=8')" class="terms-link terms">{{$t('login.termsofservice')}}</a>{{$t('login.and')}}<a hhref="javascript:void(0)" @click="openPage('/article?no=9')" class="policy-link private-policy">{{$t('login.privacypolicy')}}</a>{{$t('login.registeragreetxt2')}}</p>
										    </div>
										</div>
										<div class="form-group register-login-link-container">
										    <div tclass="link-section">
										        <p class="link-label">
													{{$t('login.alreadyhaveaccount')}}<a href="javascript:void(0)" @click="changeRegister(false)" class="site-secondary-link login-link">{{$t('common.login2')}}</a>
										        </p>
										    </div>
										</div>
									</template>
								</template>
								
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footers></footers>
		<loading v-if="isLoading"></loading>
	</div>
</template>

<script>
	import headerNavigation from '../../components/headerNavigation.vue'
	import footers from '../../components/footers.vue'
	import loading from '../../components/loading.vue'
	import {doLogin,doRegister,forgotPassword} from '../../api/api.js'
	export default {
		components: {
			headerNavigation,
			footers,
			loading
		},
		data() {
			return {
				isRegister: false,
				isMobile: false,
				isForgetPwd:false,
				isLoading:false,
				email:'',
				password:'',
				lastname:'',
				firstname:'',
				mobile:''
			};
		},
		mounted() {},
		created() {
			this.isMobile = this.webIsMobile()
		},
		methods: {
			changeRegister(e) {
				this.isRegister = e
				this.resetInput()
			},
			toForgetPwd(e){
				this.isForgetPwd = e
				this.isRegister = false
				this.resetInput()
			},
			resetInput(){
				this.email = ''
				this.password = ''
				this.mobile = ''
				this.firstname = ''
				this.lastname = ''
			},
			bindInputFocus(refName){
				var inputRef = this.$refs[refName]
				//inputRef.style = `display:none;`
				inputRef.classList.add('has-value');
			},
			handleInputBlur(refName,val){
				if(!val){
					var inputRef = this.$refs[refName]
					//inputRef.style = `display:block;`
					inputRef.classList.remove('has-value');
				}
			},
			verification() {
				if(this.isForgetPwd){
					if(!this.email){
						this.$message.warning(this.$t('tips.pleaseinputemail'));
						return false;
					}
				}else{
					if(this.isRegister){
						if(!this.firstname){
							this.$message.warning(this.$t('tips.pleaseinputfirstname'));
							return false;
						}
						if(!this.lastname){
							this.$message.warning(this.$t('tips.pleaseinputlastname'));
							return false;
						}
						if(!this.mobile){
							this.$message.warning(this.$t('tips.pleaseinputmobile'));
							return false;
						}
					}
					if(!this.email){
						this.$message.warning(this.$t('tips.pleaseinputemail'));
						return false;
					}
					if(!this.password){
						this.$message.warning(this.$t('tips.pleaseinputpwd'));
						return false;
					}
				}
				return true;
			},
			confirmLogin(){
				if(this.verification()){
					var that = this;
					let params = {
						email:this.email,
						password:this.password
					}
					that.isLoading = true
					doLogin(params).then(res => {
						that.isLoading = false
						if (res.code == 200) {
							localStorage.setItem('token', res.data.token);
							localStorage.setItem('email', that.email);
							localStorage.setItem('nickname', res.data.nickname);
							that.openPage('/')
						}else{
							that.$message.warning(res.msg);
							return false;
						}
						
					})
				}
			},
			confirmRegister(){
				if(this.verification()){
					var that = this;
					let params = {
						email:this.email,
						password:this.password,
						mobile:this.mobile,
						firstname:this.firstname,
						lastname:this.lastname
					}
					that.isLoading = true
					doRegister(params).then(res => {
						that.isLoading = false
						if (res.code == 200) {
							that.$message.success(that.$t('status.success'));
							setTimeout(() => {
								that.resetInput()
								that.isForgetPwd = false
								that.isRegister = false
							}, 1000)
							
						}else{
							that.$message.warning(res.msg);
							return false;
						}
						
					})
				}
			},
			confirmForget(){
				if(this.verification()){
					var that = this;
					let params = {
						email:this.email
					}
					that.isLoading = true
					forgotPassword(params).then(res => {
						that.isLoading = false
						if (res.code == 200) {
							that.$message.success(that.$t('status.success'));
						}else{
							that.$message.warning(res.msg);
							return false;
						}
						
					})
				}
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/login.css");

	.social-option-login-btn-container {
		margin: 0 auto 40px;
	}

	.social-option-login-btn-container .amazon-social-btn-container,
	.social-option-login-btn-container .google-social-btn-container {
		padding: 5px;
	}

	.social-option-login-btn-container .google-login-btn,
	.social-option-login-btn-container .amazon-login-btn {
		width: 300px;
	}

	.social-option-login-btn-container p {
		text-align: center;
	}

	.social-option-login-btn-container .hidden {
		display: none;
	}

	.customer-alert-warning {
		display: flex;
		align-items: center;
		margin-bottom: 16px;
		min-height: 32px;
		padding: 8px 24px;
	}

	.customer-alert-warning .error-icon {
		padding-right: 16px;
	}

	.customer-alert-warning .error-title {
		line-height: 125%;
		margin: 0;
	}

	.customer-alert-warning .error-message {
		line-height: 125%;
		margin: 0;
	}

	.comp-login-handler-container {
		display: grid;
		text-align: center;
	}

	.comp-login-handler-container .customer-form-group {
		position: relative;
		display: grid;
		grid-template-columns: 1fr max-content;
	}

	.comp-login-handler-container .customer-form-group .site-input-label {
		position: absolute;
		top: 0;
		left: 16px;
		margin-bottom: 0;
		padding: 0;
		line-height: 58px;
		opacity: .8;
		transform: scale(1);
		-webkit-transition: transform 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		-moz-transition: transform 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		-ms-transition: transform 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		-o-transition: transform 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		transition: transform 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		pointer-events: none;
		transform-origin: 0 0;
		z-index: 9;
	}

	.comp-login-handler-container .customer-form-group .site-form-input {
		height: 58px;
		padding: 12px 16px;
		transition: all .2s ease-in-out;
		box-sizing: border-box;
	}

	.comp-login-handler-container .customer-form-group .password-decrypt {
		position: absolute;
		top: 10px;
		left: 83px;
		transform: scale(.9);
		font-size: 13px;
		font-weight: 600;
		color: #757575;
		padding-left: 9px;
		border-left: 1px solid #e1e1e1;
		display: flex;
		align-items: center;
		text-transform: uppercase;
		opacity: 0;
		cursor: text;
		-webkit-transition: opacity 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		-moz-transition: opacity 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		-ms-transition: opacity 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		-o-transition: opacity 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		transition: opacity 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		text-decoration: none;
		bottom: auto;
	}

	.comp-login-handler-container .customer-form-group .password-decrypt::after {
		content: "show";
		line-height: 14px;
		padding-top: 2px;
	}

	.comp-login-handler-container .customer-form-group .password-decrypt.on::after {
		content: "hide";
	}

	.comp-login-handler-container .customer-form-group .password-decrypt .password-decrypt-icon {
		display: inline-block;
		margin-right: 5px;
		margin-top: 4px;
	}

	.comp-login-handler-container .customer-form-group.active .password-decrypt,
	.comp-login-handler-container .customer-form-group.password-decrypt-active .password-decrypt {
		opacity: 1;
		cursor: pointer;
	}

	.comp-login-handler-container .customer-form-group.active .site-input-label,
	.comp-login-handler-container .customer-form-group.has-value .site-input-label,
	.comp-login-handler-container .customer-form-group.password-decrypt-active .site-input-label {
		line-height: 13px;
		top: 13px;
		z-index: 3;
		transform: scale(.9);
	}

	.comp-login-handler-container .customer-form-group.active .site-form-input,
	.comp-login-handler-container .customer-form-group.has-value .site-form-input,
	.comp-login-handler-container .customer-form-group.password-decrypt-active .site-form-input {
		padding-top: 30px;
		letter-spacing: .25px;
		line-height: 16px;
	}

	.comp-login-handler-container .customer-form-group .site-input-group {
		grid-row: 1;
		grid-column: 1 / span 2;
	}

	.comp-login-handler-container .customer-form-group .input-message {
		grid-row: 2;
		grid-column: 1 / span 2;
	}

	.comp-login-handler-container .header-text-container {
		text-align: left;
	}

	.comp-login-handler-container .comp-login-form-container {
		display: grid;
		gap: 15px;
	}

	.comp-login-handler-container .site-form-group {
		display: grid;
		gap: 5px;
		text-align: left;
	}

	.comp-login-handler-container .site-form-input {
		width: auto;
	}

	.comp-login-handler-container .reset-email {
		text-align: left;
		cursor: pointer;
	}

	.comp-login-handler-container .forgot-password-wrapper {
		grid-row: 3;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.comp-login-handler-container .forgot-password-wrapper a {
		cursor: pointer;
	}

	.comp-login-handler-container .site-btn-primary {
		width: 100%;
		grid-row: span 1;
	}

	.comp-login-handler-container .site-btn-primary:disabled {
		cursor: not-allowed;
	}

	.comp-login-handler-container .link-section {
		display: grid;
		grid-template-columns: 1fr;
		gap: 5px;
		justify-content: center;
		align-items: center;
	}

	.comp-login-handler-container .persistent-login-wrapper {
		text-align: left;
	}

	.comp-login-handler-container .btn-container {
		text-align: center;
	}

	.comp-login-handler-container .terms span {
		display: block;
	}

	.comp-login-handler-container .error-messages-container {
		text-align: left;
	}

	.comp-login-handler-container .link-label {
		margin: 0;
		text-align: left;
	}

	.comp-login-handler-container .header-text {
		margin: 0;
	}

	.comp-login-handler-container .login-create-link {
		margin: 0;
	}
	.back-to-login-link-container {
		align-self: center;
		text-align: center;
	}
	.forget-to-login {
		text-align: center;
	}
</style>
